/*
 * Keeps the "Save X%" badge in step with whichever Kaching Bundles tier a
 * shopper has selected. The headline price is deliberately NOT changed: it
 * always shows the price of one piece.
 */
(function () {
  function parseMoney(str) {
    if (!str) return NaN;
    var cleaned = str.replace(/[^0-9.,]/g, '').replace(/,(?=\d{3}(\D|$))/g, '');
    return parseFloat(cleaned.replace(',', '.'));
  }

  function syncKachingBundlePrice(root) {
    if (!root) return;
    var checkedInput = root.querySelector('.kaching-bundles__bar input:checked');
    var bar = checkedInput
      ? checkedInput.closest('.kaching-bundles__bar')
      : root.querySelector('.kaching-bundles__bar--selected');
    if (!bar) return;

    var tier = bar.querySelector('.kaching-bundles__bar-price');
    var full = bar.querySelector('.kaching-bundles__bar-full-price');
    if (!tier) return;

    // The headline price stays at the single-piece price from the product
    // itself, so a pre-selected multi-piece bundle never makes one piece look
    // expensive. Bundle totals are shown in the bundle bars and on the buy button.

    var badge = root.querySelector('.product__savings-badge');
    if (badge) {
      var savingsSpan = badge.querySelector('span');
      var tierAmount = parseMoney(tier.textContent);
      var fullAmount = parseMoney(full && full.textContent);
      if (fullAmount > tierAmount && savingsSpan) {
        var percent = Math.round(((fullAmount - tierAmount) / fullAmount) * 100);
        savingsSpan.textContent = 'Save ' + percent + '%';
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    }
  }

  function wireBars(root) {
    var bars = root.querySelectorAll('.kaching-bundles__bar');
    if (!bars.length) return false;
    bars.forEach(function (bar) {
      var radio = bar.querySelector('input[type="radio"]');
      var main = bar.querySelector('.kaching-bundles__bar-main');
      if (radio) {
        radio.addEventListener('change', function () {
          setTimeout(function () { syncKachingBundlePrice(root); }, 60);
        });
      }
      if (main) {
        main.addEventListener('click', function () {
          setTimeout(function () { syncKachingBundlePrice(root); }, 60);
        });
      }
    });
    syncKachingBundlePrice(root);
    return true;
  }

  function initKachingBundleSync(root) {
    root = root || document;
    if (wireBars(root)) return;
    // Kaching's bars render asynchronously, well after the product info
    // markup itself, so the first attempt usually finds nothing yet.
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        if (wireBars(root)) observer.disconnect();
      });
      observer.observe(root, { childList: true, subtree: true });
    }
  }

  window.syncKachingBundlePrice = syncKachingBundlePrice;
  window.initKachingBundleSync = initKachingBundleSync;

  document.querySelectorAll('[id^="ProductInfo-"]').forEach(function (root) {
    initKachingBundleSync(root);
  });
})();
